export default "/assets/images/column-image3.4e31108bdc238012.webp";